import LabelCard from 'pages/UserPage/components/LabelCard';
import React, { useEffect, useState } from 'react';

import { ReactComponent as DiscountSchemeIcon } from '../../images/money-check-dollar.svg';
import { ReactComponent as BonusesIcon } from '../../images/bonuses.svg';
import { ReactComponent as DepositsIcon } from '../../images/square-dollar-chart.svg';
import { ReactComponent as DebtIcon } from '../../images/receipt.svg';
import Button from 'common/components/Button';
import { useNavigate, useOutletContext } from 'react-router-dom';
import SelectEl from 'common/components/Select';
import graphDateList from 'common/data/graphDateList';
import { SelectChangeEvent } from '@mui/material';
import IconButton from 'common/components/IconButton';
import { ReactComponent as FilterIcon } from 'common/icons/filter.svg';
import GraphDataProps from 'common/types/GraphDataProps';
import FinancesGraph from './components/FinancesGraph';
import CustomTable from '../../components/CustomTable';
import OrderDataTableProps from 'common/types/OrderDataTableProps';
import sendFetch from 'common/utils/fetch';


const mockData: GraphDataProps[] = [
  {
    id: 'Фінанси',
    data: [
      { x: 'Пн', y: 534 },
      { x: 'Вт', y: 435 },
      { x: 'Ср', y: 231 },
      { x: 'Чт', y: 123 },
      { x: 'Пт', y: 773 },
      { x: 'Сб', y: 534 },
      { x: 'Нд', y: 435 },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any

type ResponseProps = {
  status?: string;
  statusCode: number | string;
  orderList?: OrderDataTableProps[];
} | string;

type ResponseArray = [number, ResponseProps];

export default function UserFinancesPage() {
  //const [graphData] = useState<GraphData[]>(mockData);
  //   const [dayCount, setDayCount] = useState<number>(7);
  //   const [xType, setXType] = useState<'days' | 'weeks' | 'months'>('days');
  const [graphDate, setGraphDate] = React.useState<number>(1);
  const [bonusCount, setBonusCount] = useState<number>(0);
  const [depositCount, setDepositCount] = useState<number>(0);
  const [debtCount, setDebtCount] = useState<number>(0);
  const navigate = useNavigate();
  const handleReturn = () => {
    navigate(-1);
  };


  const handleGraphDateChange = (event: SelectChangeEvent) => {
    setGraphDate(parseInt(event.target.value));
  };
  
  // fetch orders
  const [tableData, setTableData] = useState<OrderDataTableProps[]>([]);
  const [tableLoading, setTableLoading] = useState(false);
  //const { companyId } = useAuth();
  const { userId }:{ userId: string } = useOutletContext();
  console.log(`userId: ${userId}`);

  useEffect(() => {
    const fetchTableData = async () => {
      setTableLoading(true);
      const link = 'https://api-workspace.astin.net/api/statistic/get-order-list-by-user-id';
      const response: ResponseArray = await sendFetch(`${link}`, {
        method: 'GET',
        params: {
          userId: userId,
        },
      });
      console.log(response);
      if (typeof response[1] === 'object' && 'statusCode' in response[1]) {
        if (response[0] === 200 && response[1].statusCode == 200 ) {
          setTableLoading(false);
          setTableData(response[1].orderList || []);
        } else {
          setTableLoading(false);
        }
      } else {
        setTableLoading(false);
      }
    };
    const fetchFinancialInfo = async () => {
      const link = 'https://api-workspace.astin.net/api/statistic/get-financial-info';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: [number, any] = await sendFetch(`${link}`, {
        method: 'GET',
        params: {
          userId: userId,
        },
      });
      console.log(response);
      if (response[0] === 200 && response[1]?.statusCode == 200) {
        setBonusCount(response[1].bonusCount);
        setDepositCount(response[1].depositsCount);
        setDebtCount(response[1].debt);
      }
    };
    if (userId) {
      fetchTableData();
      fetchFinancialInfo();
    }
  }, [userId]);
  


  return (
        <>
            <div className='user-finances-label-card-wrapper'>
                <LabelCard icon={<DiscountSchemeIcon className='svg-black' />} title='Дисконтна схема' value='Новачок' />
                <LabelCard icon={<BonusesIcon className='svg-black' />} title='Кількість бонусів' value={bonusCount} />
                <LabelCard icon={<DepositsIcon className='svg-black' />} title='Кількість депозитів' value={depositCount} />
                <LabelCard icon={<DebtIcon className='svg-black' />} title='Заборгованність' value={debtCount} />
            </div>
            <div className='user-stats-wrapper'>
                <div className='user-stats-element'>
                  <CustomTable loading={tableLoading} data={typeof tableData === 'object' && tableData} />
                </div>
                <div className='user-stats-element'>
                    <div className='user-stats-inner-position'>
                        <div className='user-stats-top-wrapper'>
                            <span className='big-text'>Фінанси</span>
                            <div className='user-stats-top-right'>
                                <SelectEl
                                    data={graphDateList}
                                    value={graphDate}
                                    onChange={handleGraphDateChange}
                                    height='40px'
                                />
                                <IconButton>
                                    <FilterIcon className='svg-black' />
                                </IconButton>
                            </div>
                        </div>
                        <div style={{ flex:1, position:'relative' }}>
                            <div className='user-stats-graph-wrapper'>
                                <FinancesGraph data={mockData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='user-button-wrapper right'>
                <Button type='button' onClick={handleReturn} label='Повернутись' />
            </div>
        </>
  );
}

